var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#FB6F80"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 13.7515H17.5C15.425 13.7515 13.75 15.414 13.75 17.464V31.1015C13.75 33.1515 15.425 34.8265 17.5 34.8265H18.45C19.4375 34.8265 20.4 35.214 21.1 35.914L23.2375 38.0265C24.2125 38.989 25.7875 38.989 26.7625 38.0265L28.9 35.914C29.6 35.214 30.5625 34.8265 31.55 34.8265H32.5C34.575 34.8265 36.25 33.1515 36.25 31.1015V17.464C36.25 15.414 34.575 13.7515 32.5 13.7515ZM25 18.189C26.35 18.189 27.4375 19.289 27.4375 20.6265C27.4375 21.9515 26.3875 23.014 25.0875 23.064C25.0375 23.064 24.9625 23.064 24.9 23.064C23.5875 23.014 22.55 21.9515 22.55 20.6265C22.5625 19.289 23.65 18.189 25 18.189ZM28.4375 29.614C26.55 30.8765 23.45 30.8765 21.5625 29.614C19.9 28.514 19.9 26.689 21.5625 25.5765C23.4625 24.314 26.5625 24.314 28.4375 25.5765C30.1 26.689 30.1 28.5015 28.4375 29.614Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFix);
export default __webpack_public_path__ + "static/media/icon_fix.f002571e2ad8aef04cf9959b798e88c5.svg";
export { ForwardRef as ReactComponent };